import Loadable from 'app/components/Loadable';
import { lazy } from 'react';
import { authRoles } from '../../auth/authRoles';

const CategoryList = Loadable(lazy(() => import('./SubCategoryList')));
const AddCategory = Loadable(lazy(() => import('./AddSubCategory')));
const EditCategory = Loadable(lazy(() => import('./EditCategoryForm')));

const SubCategoryRoutes = [
	{
		path: '/subcategory/list',
		element: <CategoryList />,
		auth: authRoles.admin,
	},
	{
		path: '/subcategory/list/edit',
		element: <EditCategory />,
		auth: authRoles.admin,
	},
	{
		path: '/subcategory/add',
		element: <AddCategory />,
		auth: authRoles.admin,
	},
];

export default SubCategoryRoutes;
